// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"349":"708ae2e5","354":"df1a064f","418":"8abd199e"}[chunkId] + ".js";
};